module.exports = __webpack_public_path__ + "img/chatham-logo.5f59ca81.png";